module.exports = __webpack_public_path__ + "static/media/wipe.f4a1343b.mp3";